<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid style="height: auto">
        <v-row>
            <span>Условия:</span>
        </v-row>
        <v-row v-for="(item, indexItem) in modelItems"
               :key="indexItem"
        >
            <v-col cols="1" class="pa-0 mx-1">
                <v-select
                        v-model="item[0]"
                        :items="[{value: 1, text: 'И'}, {value: 2, text: 'ИЛИ'}]"
                        hide-details
                        @change="changeItems"
                        v-if="indexItem > 0"
                ></v-select>
                <v-text-field value="Если" disabled hide-details v-else></v-text-field>
            </v-col>
            <v-col cols="3" class="pa-0 mx-1">
                <v-select
                        v-model="modelItems[indexItem][1]"
                        :items="variablesToConditions"
                        hide-details
                        @change="changeVariableToCondition(indexItem)"
                ></v-select>
            </v-col>
            <v-col cols="3" class="pa-0 mx-1" v-show="modelItems[indexItem][1] === 1">
                <v-select
                        v-model="modelItems[indexItem][2]"
                        :items="scenarios.variables"
                        item-text="title"
                        item-value="id"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col cols="1" class="pa-0 mx-0">
                <v-select
                        v-model="modelItems[indexItem][3]"
                        :items="getConditionType(modelItems[indexItem][1])"
                        hide-details
                        @change="changeItems"
                ></v-select>
            </v-col>
            <v-col :cols="modelItems[indexItem][1] === 2 ? 3: 1" class="pa-0 mx-2" v-show="viewValueField(modelItems[indexItem])">
                <!--значение -->
                <v-text-field v-model="modelItems[indexItem][4]" hide-details @input="changeItems"></v-text-field>
            </v-col>
            <v-col cols="2" class="pa-0 mx-1 my-2" v-show="modelItems[indexItem][1] === 2">
                <v-menu
                    v-model="postsShow"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn  v-on="on" small title="Выбери пост с помощью кнопки или скопируй ссылку на пост">
                            <span class="text-none caption">Выбрать пост</span></v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                                v-for="item in posts.posts"
                                :key="item.id"
                                @click="writeValueToPost(indexItem, item.id)"
                        >
                            <v-list-item-title><span class="text-none caption">{{ item.title }}</span></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </v-col>
            <v-col cols="1" v-if="indexItem > 0">
                <v-icon title="Удалить" small @click="deleteItem(indexItem)">delete</v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-btn @click="addCondition" class="py-1 my-2" small><span class="text-none caption">Добавить условие</span></v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'ModuleConditions',
    data() {
        return {
            selectedItems: [],
            variablesToConditions: [
                { text: 'Переменная', value: 1 },
                { text: 'Репост записи', value: 2 },
                { text: 'Лайк записи', value: 3 },
                { text: 'Подписчик', value: 4 },
                { text: 'Пол', value: 5 },
                { text: 'Бот включен', value: 6 },
                { text: 'Ввод пользователя', value: 7 },
                { text: 'Комментарий поста', value: 8 }
            ],
            conditionTypes: [
                { text: '=', value: 1 },
                { text: '≠', value: 2 },
                { text: '<', value: 3 },
                { text: '⩽', value: 4 },
                { text: '>', value: 5 },
                { text: '⩾', value: 6 },
                { text: 'Есть', value: 7 },
                { text: 'Нет', value: 8 },
                { text: 'Да', value: 9 },
                { text: 'Мужской', value: 10 },
                { text: 'Женский', value: 11 },
                { text: 'Не указан', value: 12 },
                { text: '= t', value: 13 },
                { text: '≠ t', value: 14 },
                { text: '< t', value: 15 },
                { text: '⩽ t', value: 16 },
                { text: '> t', value: 17 },
                { text: '⩾ t', value: 18 },
                { text: '< d', value: 19 },
                { text: '> d', value: 20 }
            ],
            mainString: [0, 1, 0, 0, ''],
            postsShow: false
        }
    },
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    computed: {
        ...mapState(['scenarios', 'posts'])
    },
    methods: {
        getConditionType(variableToConditionId) {
            switch (variableToConditionId) {
            case 1:
                return this.getConditionTypesByIndexes([0, 1, 2, 3, 4, 5])
            case 2:
                return this.getConditionTypesByIndexes([6, 7, 2, 4])
            case 3:
                return this.getConditionTypesByIndexes([6, 7])
            case 4:
                return this.getConditionTypesByIndexes([7, 8])
            case 5:
                return this.getConditionTypesByIndexes([9, 10, 11])
            case 6:
                return this.getConditionTypesByIndexes([7, 8])
            default:
                return this.getConditionTypesByIndexes([0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 17, 18, 19, 6, 7])
            }
        },
        getConditionTypesByIndexes(indexes) {
            let conditionTypes = []
            indexes.forEach((index) => {
                conditionTypes.push(this.conditionTypes[index])
            })
            return conditionTypes
        },
        changeItems() {
            this.$emit('updateItems', { items: this.modelItems, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        addCondition() {
            this.modelItems.push([1, 1, 0, 0, ''])
            this.changeItems()
        },
        changeVariableToCondition(indexItem) {
            this.modelItems[indexItem][3] = this.getConditionType(this.modelItems[indexItem][1])[0].value
            this.changeItems()
        },
        deleteItem(indexItem) {
            this.modelItems.splice(indexItem, 1)
            this.changeItems()
        },
        writeValueToPost(indexItem, postId) {
            this.modelItems[indexItem][4] = '{"post_id":' + postId + '}'
        },
        viewValueField(modelItem) {
            return modelItem[1] !== 4 && modelItem[1] !== 5 && modelItem[1] !== 6
        }
    },
    created() {
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
        this.$store.dispatch('posts/postAll', this.$route.params['pathMatch'])
    }

}
</script>

<style scoped>
    .container {
        height: auto;
    }
    .v-text-field {
        font-size: 0.9em;
    }
    .v-list-item-title {
        font-size: 0.9em;
    }
</style>
